import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';

import { MessageService } from '@services';
import { RepresentantesServiceV2 } from '@servicesv2';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RepresentantesViewModel } from 'models/representantes/RepresentantesViewModel';
import { ComboboxPadrao } from 'models/combobox-padrao/combobox-padrao';

@Component({
  selector: 'app-combobox-representantes',
  templateUrl: './combobox-representantes.component.html',
  styleUrls: ['./combobox-representantes.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboboxRepresentantesComponent),
      multi: true
    }
  ]
})
export class ComboboxRepresentantesComponent extends ComboboxPadrao<RepresentantesViewModel> implements ControlValueAccessor {
  override bindLabel = 'nome';
  override label = 'Vendedores';
  @Input() override required = false;
  @Input() override requiredText = 'O vendedor é obrigatório';

  @Input() loading = false;
  @Input() disabled = false;
  @Input() notFoundPlusIcon = true;
  @Input() pencilIcon = true;
  @Output() changed = new EventEmitter();

  constructor(
    service: RepresentantesServiceV2,
    message: MessageService,
  ) {
    super('combobox_representantes', message, service);
  }

  writeValue(value: number): void {
    this.selected.setValue(value);
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  handleOnChanged(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }

  handleOnAdded(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }

  handleOnEdited(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }
}
